import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {
  PoBreadcrumb,
  PoComboComponent,
  PoDialogService,
  PoModalComponent,
  PoPageAction,
  PoPageFilter,
  PoPageListComponent,
  PoTableAction,
  PoTableColumn,
  PoTableColumnSpacing,
  PoTableComponent
} from '@po-ui/ng-components';
import { SchemaBuilderService } from '../../core/menu/schema-builder.service';
import { ShortcutService } from '../../core/shortcut/shortcut.service';
import { Subscription, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SalasService } from './salas.service'; //

@Component({
  selector: 'app-salas',
  templateUrl: './salas.component.html',
  styleUrl: './salas.component.css',
  standalone: false
})
export class SalasComponent implements OnInit, OnDestroy {

  @ViewChild('dynamicTable', { static: true }) dynamicTable!: PoTableComponent;
  @ViewChild('pageListComponent', { static: true }) pageListComponent!: PoPageListComponent;
  @ViewChild('modalEditUsers') modalEditUsers!: PoModalComponent;
  @ViewChild('modalAddUser') modalAddUser!: PoModalComponent;
  @ViewChild('modalHorarios') modalHorarios!: PoModalComponent;
  @ViewChild('modalAccessLogs') modalAccessLogs!: PoModalComponent;
  @ViewChild('modalCopyFromRoom') modalCopyFromRoom!: PoModalComponent;
  @ViewChild('userFilterCombo') userFilterCombo!: PoComboComponent;

  isHideLoading = true;
  isHideLoadingUsers = true;
  isHideLoadingAccessLogs = true;
  items: any[] = [];
  columns: Array<PoTableColumn> = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;
  moreItens: boolean = false;
  page: number = 1;
  pageSize: number = 100;
  filter: string = '';
  disclaimerGroup: any;
  private disclaimers: any[] = [];
  private shortcutSubscription!: Subscription;

  selectedRoom: any = null;
  roomUsers: any[] = [];
  roomUsersFiltered: any[] = [];
  roomUsersPage: number = 1;
  roomUsersPageSize: number = 100;
  roomUsersHasMore: boolean = false;
  roomUsersRoomId: string = ''; // Armazena o roomId para próximas requisições
  selectedUserForHorarios: any = null;
  scheduleTableItems: any[] = [];
  accessLogs: any[] = [];
  accessLogsPage: number = 1;
  accessLogsPageSize: number = 50;
  accessLogsHasMore: boolean = false;
  accessLogsRoomId: string = ''; // Armazena o roomId para próximas requisições
  accessLogsDeviceMacAddress: string = ''; // Armazena o MAC address do dispositivo
  accessLogsDevice: any = null; // Armazena o dispositivo para usar nas próximas requisições
  accessLogDateRange: any = null; // Armazena o período de data selecionado para filtrar os logs
  accessLogsSearchText: string = '';
  accessLogsAll: any[] = []; // Armazena todos os logs carregados (sem filtro)

  copyFromRoomList: any[] = [];
  selectedSourceRoomForCopy: any = null;
  isHideLoadingCopyRooms = true;
  replicatingAccess = false;

  userFilterText = '';
  usersComboOptions: Array<{ label: string; value: string }> = [];
  userToAdd: any = null;
  private userSearchSubject = new Subject<string>();
  private userSearchSubscription?: Subscription;
  private accessLogsSearchSubject = new Subject<string>();
  private accessLogsSearchSubscription?: Subscription;
  usersToAddOptions: Array<{ label: string; value: string }> = [];
  addingHorarioForUser: any = null;
  editingScheduleIndex: number | null = null;
  modalEditarHorarioError = '';
  diasSelecionados: string[] = [];
  diasSemanaComAtivoSelecionados: string[] = [];
  horaInicio = '';
  horaTermino = '';
  horarioAtivo = true;
  savingAddUser = false;

  readonly usersTableColumns: Array<PoTableColumn> = [
    { property: 'tag', label: 'Tag', width: '10%' },
    { property: 'displayName', label: 'Nome do Usuário', width: '80%' },
    { property: 'actions', label: 'Revogar', type: 'cellTemplate', width: '10%' }
  ];

  readonly scheduleTableColumns: Array<PoTableColumn> = [
    { property: 'dia', label: 'Dias', width: '60%' },
    { property: 'startTime', label: 'Hora de início', width: '15%' },
    { property: 'endTime', label: 'Hora de término', width: '15%' },
    { property: 'actions', label: 'Excluir', type: 'cellTemplate', width: '10%' }
  ];

  readonly copyFromRoomTableColumns: Array<PoTableColumn> = [
    { property: 'alias', label: 'Sala', width: '35%' },
    { property: 'description', label: 'Descrição', width: '65%' }
  ];

  readonly accessLogsTableColumns: Array<PoTableColumn> = [
    { property: 'accessDate', label: 'Data/Hora', width: '18%' },
    { property: 'userName', label: 'Usuário', width: '20%' },
    { property: 'userTag', label: 'Tag', width: '10%' },
    { property: 'accessType', label: 'Status', width: '12%' },
    { property: 'deviceName', label: 'Dispositivo', width: '15%' },
    { property: 'actions', label: 'Detalhes', type: 'cellTemplate', width: '10%' }
  ];

  readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Controle de Acesso' }, { label: 'Salas' }]
  };

  readonly pageActions: Array<PoPageAction> = [
    { label: 'Nova Sala', action: () => this.router.navigate(['/rooms-edit']), icon: 'an an-plus' },
    { label: 'Atualizar', action: () => this.loadMore(true), icon: 'an an-arrows-clockwise' }
  ];

  readonly actions: PoTableAction[] = [
    { label: 'Editar Registro', action: (item: any) => this.router.navigate(['/rooms-edit', item.id]), icon: 'an an-pencil' },
    { label: 'Editar usuários da sala', action: this.editUsers.bind(this), icon: 'po-icon po-icon-users' },
    { label: 'Registro de Acesso', action: this.openAccessLogs.bind(this), icon: 'po-icon po-icon-list' },
    { label: 'Deletar Registro', action: this.confirmDelete.bind(this), icon: 'an an-trash', type: 'danger', separator: true },
    { label: 'Visualizar Detalhes', icon: 'po-icon po-icon-eye' } // Restaurado!
  ];

  readonly diasSemanaComAtivoOptions = [
    { label: 'SEG', value: 'seg' }, { label: 'TER', value: 'ter' }, { label: 'QUA', value: 'qua' },
    { label: 'QUI', value: 'qui' }, { label: 'SEX', value: 'sex' }, { label: 'SÁB', value: 'sab' },
    { label: 'DOM', value: 'dom' }, { label: 'Ativo', value: 'ativo' }
  ];

  public readonly filterSettings: PoPageFilter = { action: this.filterAction.bind(this), placeholder: 'Pesquisar' };

  constructor(
    private schemaBuilderService: SchemaBuilderService,
    private poDialogService: PoDialogService,
    private shortcutService: ShortcutService,
    private router: Router,
    private salasService: SalasService //
  ) { }

  ngOnInit(): void {
    this.schemaBuilderService.getTableSchema('rooms').subscribe(data => this.columns = this.transformTableSchema(data as any[]));
    this.disclaimerGroup = { title: 'Filtros:', disclaimers: [], change: this.onChangeDisclaimer.bind(this), remove: this.onClearDisclaimer.bind(this) };
    this.shortcutSubscription = this.shortcutService.getShortcuts().subscribe((event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'b') this.router.navigate(['/rooms-edit']);
      if (event.ctrlKey && event.key === 'f') this.pageListComponent.filterInput.nativeElement.focus();
    });
    this.loadMore();
  }

  ngOnDestroy(): void {
    if (this.shortcutSubscription) this.shortcutSubscription.unsubscribe();
    if (this.userSearchSubscription) this.userSearchSubscription.unsubscribe();
    if (this.accessLogsSearchSubscription) this.accessLogsSearchSubscription.unsubscribe();
  }

  onFilterUserChange(event: any) {
    // Dispara a busca na API com debounce
    this.userSearchSubject.next(this.userFilterText);
  }

  onFilterUserInput(event: any) {
    // Dispara a busca na API com debounce
    this.userSearchSubject.next(this.userFilterText);
  }

  onFilterUserBlur() {
    // Dispara a busca na API com debounce
    this.userSearchSubject.next(this.userFilterText);
  }

  private searchUsersInAPI(searchTerm: string) {
    if (!this.roomUsersRoomId) return;

    this.isHideLoadingUsers = false;
    this.roomUsers = [];
    this.roomUsersPage = 1;

    this.salasService.getUsersByRoom(this.roomUsersRoomId, true, 1, this.roomUsersPageSize, searchTerm).subscribe({
      next: (response: any) => {
        const usersData = response.items || response.data || response || [];

        // Mapeia os usuários recebidos
        const mappedUsers = (usersData || []).map((u: any) => ({
          ...u,
          displayName: u?.isMaster === true
            ? `${u?.name || u?.tag || u?.id || ''} (Master)`
            : (u?.name || u?.tag || u?.id || '')
        }));

        this.roomUsers = mappedUsers;
        this.roomUsersFiltered = [...this.roomUsers];
        this.usersComboOptions = this.roomUsers.map(u => ({ label: u.name || u.tag, value: u.id }));

        this.roomUsersHasMore = response.hasNext || false;
        this.isHideLoadingUsers = true;
      },
      error: () => {
        this.isHideLoadingUsers = true;
      }
    });
  }

  filterRoomUsersTable() {
    // Mantido para compatibilidade, mas agora a busca é feita na API
    const term = this.userFilterText.toLowerCase();
    this.roomUsersFiltered = term ? this.roomUsers.filter(u => (u.name || u.tag || '').toLowerCase().includes(term)) : [...this.roomUsers];
  }

  editUsers(item: any) {
    this.selectedRoom = item;
    this.userFilterText = '';
    this.setupUserSearch();
    this.loadRoomUsers(item.id);
    this.modalEditUsers.open();
  }

  private setupUserSearch() {
    // Cancela subscription anterior se existir
    if (this.userSearchSubscription) {
      this.userSearchSubscription.unsubscribe();
    }

    // Configura o debounce para busca na API
    this.userSearchSubscription = this.userSearchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      if (searchTerm && searchTerm.trim()) {
        this.searchUsersInAPI(searchTerm.trim());
      } else {
        // Se não há busca, recarrega todos os usuários
        this.loadRoomUsers(this.selectedRoom.id, undefined, true);
      }
    });
  }

  openAccessLogs(item: any) {
    this.selectedRoom = item;
    // Reseta tudo para garantir paginação limpa
    this.accessLogs = [];
    this.accessLogsAll = [];
    this.accessLogsPage = 1;
    this.accessLogsHasMore = false;
    this.accessLogsRoomId = '';
    this.accessLogsDeviceMacAddress = '';
    this.accessLogsDevice = null;
    this.accessLogsSearchText = '';
    this.isHideLoadingAccessLogs = false;
    this.setupAccessLogsSearch();
    this.modalAccessLogs.open();
    // Carrega os logs após abrir o modal
    this.loadAccessLogs(item, true);
  }

  loadRoomUsers(roomId: string, userIdToRefresh?: string, reset: boolean = true) {
    this.isHideLoadingUsers = false;

    // Se for reset, limpa tudo e reinicia a paginação
    if (reset) {
      this.roomUsers = [];
      this.roomUsersPage = 1;
      this.roomUsersHasMore = false;
      this.roomUsersRoomId = '';
    }

    // Armazena o roomId para próximas requisições
    if (!this.roomUsersRoomId) {
      this.roomUsersRoomId = roomId;
    }

    // Se já temos o roomId e não é reset, faz a requisição diretamente
    if (this.roomUsersRoomId && !reset) {
      this.loadMoreRoomUsers(userIdToRefresh);
      return;
    }

    // Busca os usuários usando paginação
    this.loadMoreRoomUsers(userIdToRefresh);
  }

  loadMoreRoomUsers(userIdToRefresh?: string) {
    if (!this.roomUsersRoomId) {
      this.isHideLoadingUsers = true;
      return;
    }

    this.isHideLoadingUsers = false;

    this.salasService.getUsersByRoom(this.roomUsersRoomId, true, this.roomUsersPage, this.roomUsersPageSize).subscribe({
      next: (response: any) => {
        const usersData = response.items || response.data || response || [];
        const hasNext = response.hasNext !== undefined ? response.hasNext : (usersData.length >= this.roomUsersPageSize);

        // Mapeia os usuários recebidos
        const mappedUsers = (usersData || []).map((u: any) => ({
          ...u,
          displayName: u?.isMaster === true
            ? `${u?.name || u?.tag || u?.id || ''} (Master)`
            : (u?.name || u?.tag || u?.id || '')
        }));

        // Se a API retornou mais itens que o pageSize, pega apenas os primeiros pageSize
        const usersToAdd = mappedUsers.slice(0, this.roomUsersPageSize);

        // Adiciona os novos usuários ao array existente (não substitui, adiciona)
        this.roomUsers = [...this.roomUsers, ...usersToAdd];
        this.roomUsersFiltered = [...this.roomUsers];
        this.usersComboOptions = this.roomUsers.map(u => ({ label: u.name || u.tag, value: u.id }));

        // Atualiza o controle de paginação
        if (mappedUsers.length > this.roomUsersPageSize) {
          this.roomUsersHasMore = true;
        } else {
          this.roomUsersHasMore = hasNext;
        }

        // Incrementa a página APENAS se houver mais itens para carregar
        if (this.roomUsersHasMore) {
          this.roomUsersPage++;
        }

        if (userIdToRefresh) this.refreshUserSchedule(userIdToRefresh);
        this.isHideLoadingUsers = true;
      },
      error: () => {
        this.isHideLoadingUsers = true;
      }
    });
  }

  addUser() {
    this.addingHorarioForUser = null; // Garante que o combo de seleção de usuário APAREÇA
    this.editingScheduleIndex = null;
    this.userToAdd = null;
    this.resetHorarioForm();
    this.loadUsersToAddOptions();
    this.modalAddUser.open();
  }

  addHorario() {
    this.addingHorarioForUser = this.selectedUserForHorarios; // Garante que o combo de seleção de usuário NÃO APAREÇA
    this.editingScheduleIndex = null;
    this.resetHorarioForm();
    this.modalAddUser.open();
  }

  selecionaUsuario(row: any) {
    if (row?.isMaster === true) {
      this.poDialogService.alert({
        title: 'Usuário Master',
        message: 'Este é um usuário Master e tem acesso irrestrito. Para alterar o status, utilize a página "Funcionários".'
      });
      return;
    }
    this.openHorariosModal(row);
  }

  openHorariosModal(user: any) {
    this.selectedUserForHorarios = user;
    this.scheduleTableItems = this.salasService.buildScheduleTableItems(user.schedule || user.schedules); //
    this.modalHorarios.open();
  }

  onScheduleRowSelected(row: any) {
    const raw = row._raw;
    this.addingHorarioForUser = this.selectedUserForHorarios;
    this.editingScheduleIndex = row._index;
    this.diasSelecionados = this.salasService.daysNumberToDayKeys(raw.days);
    this.horarioAtivo = raw.isActive ?? true;
    this.diasSemanaComAtivoSelecionados = this.horarioAtivo ? [...this.diasSelecionados, 'ativo'] : [...this.diasSelecionados];
    this.horaInicio = this.salasService.formatTimeForDisplay(raw.startTime);
    this.horaTermino = this.salasService.formatTimeForDisplay(raw.endTime);
    this.modalAddUser.open();
  }

  confirmAddUser() {
    const isAddingHorario = !!this.addingHorarioForUser;
    const userId = isAddingHorario
      ? (this.addingHorarioForUser?.id || this.addingHorarioForUser?.value)
      : this.userToAdd;

    if (!userId || !this.selectedRoom?.id) return;

    if (this.diasSelecionados.length === 0) {
      this.modalEditarHorarioError = 'É necessário adicionar pelo menos um dia';
      return;
    }

    const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    if (!timeRegex.test(this.horaInicio) || !timeRegex.test(this.horaTermino)) {
      this.modalEditarHorarioError = 'Horários inválidos (HH:mm)';
      return;
    }

    this.modalEditarHorarioError = '';

    const newScheduleItem = {
      days: this.salasService.calculateDaysValue(this.diasSelecionados),
      startTime: this.salasService.formatTimeToSeconds(this.horaInicio),
      endTime: this.salasService.formatTimeToSeconds(this.horaTermino),
      isActive: this.horarioAtivo
    };

    let finalSchedules: any[] = [];

    if (isAddingHorario) {
      const existing = this.salasService.getExistingSchedules(this.addingHorarioForUser);

      if (this.editingScheduleIndex !== null && this.editingScheduleIndex >= 0) {
        finalSchedules = [...existing];
        finalSchedules[this.editingScheduleIndex] = newScheduleItem;
      } else {
        finalSchedules = [...existing, newScheduleItem];
      }
    } else {
      finalSchedules = [newScheduleItem];
    }

    const payload = {
      userId,
      roomId: this.selectedRoom.id,
      isActive: this.horarioAtivo,
      schedules: finalSchedules
    };

    this.savingAddUser = true;
    this.salasService.grantAccess(payload).subscribe({
      next: () => {
        this.savingAddUser = false;
        this.closeAddUserModal();
        // Atualiza a lista de usuários e, se estiver editando horário, atualiza a tabela de horários também
        this.loadRoomUsers(this.selectedRoom.id, userId);
        // Se estava editando horário de um usuário específico, atualiza a tabela de horários
        if (isAddingHorario && this.selectedUserForHorarios?.id === userId) {
          setTimeout(() => {
            this.refreshUserSchedule(userId);
          }, 300);
        }
      },
      error: (err) => {
        this.savingAddUser = false;
        this.poDialogService.alert({ title: 'Erro', message: err.message });
      }
    });
  }

  private refreshUserSchedule(userId: string) {
    const user = this.roomUsers.find(u => u.id === userId);
    if (user) {
      this.selectedUserForHorarios = user;
      this.scheduleTableItems = this.salasService.buildScheduleTableItems(user.schedule || user.schedules);
    }
  }

  private resetHorarioForm() {
    this.diasSelecionados = [];
    this.diasSemanaComAtivoSelecionados = ['ativo'];
    this.horaInicio = '';
    this.horaTermino = '';
    this.modalEditarHorarioError = '';
  }

  loadUsersToAddOptions() {
    this.salasService.getUsersByRoom(this.selectedRoom.id, false, 1, 100).subscribe((response: any) => {
      const usersData = response.items || response.data || response || [];
      this.usersToAddOptions = usersData.map((u: any) => ({ label: u.name || u.tag, value: u.id }));
    });
  }

  loadMore(reset = false) {
    if (reset) {
      this.page = 1;
      this.items = [];
    }
    this.isHideLoading = false;
    this.salasService.getSalas(this.page, this.pageSize, this.filter).subscribe({
      next: (data: any) => {
        this.items = reset ? data.items : [...this.items, ...data.items];
        this.moreItens = data.hasNext;
        this.page++;
        this.isHideLoading = true;
      },
      error: () => this.isHideLoading = true
    });
  }
  removeUserAccess(user: any) {
    if (user?.isMaster === true) {
      this.poDialogService.alert({
        title: 'Usuário Master',
        message: 'Este é um usuário Master e tem acesso irrestrito.'
      });
      return;
    }
    this.poDialogService.confirm({
      title: 'Revogar Acesso',
      message: `Deseja realmente remover o acesso de ${user.name || user.tag} a esta sala?`,
      literals: { confirm: 'Revogar', cancel: 'Cancelar' },
      confirm: () => {
        this.isHideLoadingUsers = false;
        this.salasService.revokeAccess(user.id, this.selectedRoom.id).subscribe({
          next: () => {
            this.loadRoomUsers(this.selectedRoom.id);
            // Se o usuário removido era o selecionado para horários, limpa a seleção
            if (this.selectedUserForHorarios?.id === user.id) {
              this.selectedUserForHorarios = null;
              this.scheduleTableItems = [];
            }
          },
          error: (err) => {
            this.isHideLoadingUsers = true;
            this.poDialogService.alert({ title: 'Erro', message: err.message || 'Erro ao revogar.' });
          }
        });
      }
    });
  }

  removeScheduleItem(item: any) {
    const indexToRemove = item._index;
    this.poDialogService.confirm({
      title: 'Excluir Horário',
      message: 'Esta ação excluirá apenas este intervalo de tempo. Prosseguir?',
      confirm: () => {
        const existingSchedules = this.salasService.getExistingSchedules(this.selectedUserForHorarios);
        const newSchedules = existingSchedules.filter((_, i) => i !== indexToRemove);

        // Se não restarem horários, revoga o acesso completamente
        if (newSchedules.length === 0) {
          this.salasService.revokeAccess(this.selectedUserForHorarios.id, this.selectedRoom.id).subscribe({
            next: () => {
              // Atualiza a lista de usuários
              this.loadRoomUsers(this.selectedRoom.id);
              // Fecha o modal de horários já que o usuário não tem mais acesso
              this.modalHorarios.close();
              this.selectedUserForHorarios = null;
              this.scheduleTableItems = [];
            },
            error: (err) => this.poDialogService.alert({ title: 'Erro', message: err.message || 'Erro ao revogar acesso.' })
          });
        } else {
          // Se ainda há horários, atualiza apenas os schedules
          const payload = {
            userId: this.selectedUserForHorarios.id,
            roomId: this.selectedRoom.id,
            isActive: this.selectedUserForHorarios.isActive ?? true,
            schedules: newSchedules
          };

          this.salasService.grantAccess(payload).subscribe({
            next: () => {
              // Atualiza a lista de usuários e a tabela de horários
              this.loadRoomUsers(this.selectedRoom.id, this.selectedUserForHorarios.id);
              // Garante que a tabela de horários seja atualizada após a exclusão
              setTimeout(() => {
                this.refreshUserSchedule(this.selectedUserForHorarios.id);
              }, 300);
            },
            error: (err) => this.poDialogService.alert({ title: 'Erro', message: err.message })
          });
        }
      }
    });
  }

  confirmDelete(item: any) {
    this.poDialogService.confirm({
      title: 'Exclusão de Registro',
      message: `Deseja realmente excluir a sala "${item.alias || item.name}"? Esta ação não pode ser desfeita.`,
      literals: { confirm: 'Excluir', cancel: 'Cancelar' },
      confirm: () => this.remove(item)
    });
  }

  private remove(item: any) {
    this.isHideLoading = false;
    this.salasService.deleteSala(item.id).subscribe({
      next: () => {
        this.isHideLoading = true;
        this.poDialogService.alert({ title: 'Sucesso', message: 'Sala excluída com sucesso!' });
        this.loadMore(true); // Recarrega a tabela para atualizar a lista
      },
      error: (err) => {
        this.isHideLoading = true;
        this.poDialogService.alert({
          title: 'Erro',
          message: err.error?.message || 'Não foi possível excluir a sala. Verifique se há usuários vinculados.'
        });
      }
    });
  }


  onDiasSemanaComAtivoChange(s: string[]) { this.diasSelecionados = s.filter(v => v !== 'ativo'); this.horarioAtivo = s.includes('ativo'); }
  onUserToAddChange(v: any) { this.userToAdd = v; }
  closeAddUserModal() { this.modalAddUser.close(); }
  closeHorariosModal() { this.modalHorarios.close(); }
  private transformTableSchema(s: any[]) { return s.filter(f => f.visible !== false).map(f => ({ property: f.property, label: f.label })); }
  filterAction(f: any) { this.filter = f; this.loadMore(true); }
  onChangeDisclaimer(d: any) { this.loadMore(true); }
  onClearDisclaimer(d: any) { this.filter = ''; this.loadMore(true); }


  get modalEditUsersTitle(): string {
    const alias = this.selectedRoom?.alias ?? this.selectedRoom?.Alias ?? this.selectedRoom?.name ?? this.selectedRoom?.Name ?? '';
    const description = this.selectedRoom?.description ?? this.selectedRoom?.Description ?? '';
    if (description) {
      return `Usuários com acesso à Sala ${alias} (${description})`;
    }
    return alias ? `Usuários com acesso à Sala ${alias}` : 'Usuários com acesso à Sala';
  }

  get modalEditarHorarioTitle(): string {
    if (!this.addingHorarioForUser) {
      const alias = this.selectedRoom?.alias ?? this.selectedRoom?.Alias ?? this.selectedRoom?.name ?? this.selectedRoom?.Name ?? '';
      const description = this.selectedRoom?.description ?? this.selectedRoom?.Description ?? '';
      if (description) {
        return `Adicionar usuário à sala ${alias} (${description})`;
      }
      return alias ? `Adicionar usuário à sala ${alias}` : 'Adicionar usuário à sala';
    }
    return 'Editar horário';
  }

  get modalHorariosTitle(): string {
    const alias = this.selectedRoom?.alias ?? this.selectedRoom?.Alias ?? this.selectedRoom?.name ?? this.selectedRoom?.Name ?? '';
    const description = this.selectedRoom?.description ?? this.selectedRoom?.Description ?? '';
    if (description) {
      return `Horários - Sala ${alias} (${description})`;
    }
    return alias ? `Horários - Sala ${alias}` : 'Horários';
  }

  get modalAccessLogsTitle(): string {
    const alias = this.selectedRoom?.alias ?? this.selectedRoom?.Alias ?? this.selectedRoom?.name ?? this.selectedRoom?.Name ?? '';
    const description = this.selectedRoom?.description ?? this.selectedRoom?.Description ?? '';
    if (description) {
      return `Registro de Acesso - Sala ${alias} (${description})`;
    }
    return alias ? `Registro de Acesso - Sala ${alias}` : 'Registro de Acesso';
  }

  get modalCopyFromRoomTitle(): string {
    return 'Copiar registro de outra sala';
  }

  openCopyFromRoomModal(): void {
    this.selectedSourceRoomForCopy = null;
    this.copyFromRoomList = [];
    this.isHideLoadingCopyRooms = false;
    this.modalCopyFromRoom.open();
    this.salasService.getSalas(1, 500, '').subscribe({
      next: (data: any) => {
        const allRooms: any[] = data.items ?? [];
        const currentId = this.selectedRoom?.id;
        this.copyFromRoomList = allRooms
          .filter((r: any) => (r.id || r.Id) !== currentId)
          .map((r: any) => ({
            id: r.id ?? r.Id,
            alias: r.alias ?? r.Alias ?? r.name ?? r.Name ?? '-',
            description: r.description ?? r.Description ?? ''
          }));
        this.isHideLoadingCopyRooms = true;
      },
      error: () => {
        this.isHideLoadingCopyRooms = true;
        this.poDialogService.alert({ title: 'Erro', message: 'Não foi possível carregar a lista de salas.' });
      }
    });
  }

  onCopySourceRoomSelected(event: any): void {
    const selected = Array.isArray(event) ? event[0] : event;
    this.selectedSourceRoomForCopy = selected && typeof selected === 'object' && selected.id != null ? selected : null;
  }

  confirmCopyFromRoom(): void {
    if (!this.selectedSourceRoomForCopy || !this.selectedRoom?.id) {
      this.poDialogService.alert({
        title: 'Atenção',
        message: 'Selecione uma sala de origem para copiar os registros.'
      });
      return;
    }
    const sourceName = this.selectedSourceRoomForCopy.alias || this.selectedSourceRoomForCopy.description || 'sala de origem';
    const targetName = this.selectedRoom?.alias ?? this.selectedRoom?.name ?? 'esta sala';
    this.poDialogService.confirm({
      title: 'Atenção - Substituição de registros',
      message: `Esta ação irá APAGAR todos os usuários e horários de acesso atuais da sala "${targetName}" e substituir pelos registros da sala "${sourceName}". Não é possível desfazer. Deseja continuar?`,
      literals: { confirm: 'Sim, copiar e substituir', cancel: 'Cancelar' },
      confirm: () => {
        this.replicatingAccess = true;
        this.salasService.replicateRoomAccess(this.selectedSourceRoomForCopy.id, this.selectedRoom.id).subscribe({
          next: (res) => {
            this.replicatingAccess = false;
            this.modalCopyFromRoom.close();
            this.loadRoomUsers(this.selectedRoom.id, undefined, true);
            this.poDialogService.alert({
              title: 'Cópia concluída',
              message: res?.message ?? `Foram copiados ${res?.replicatedCount ?? 0} registro(s) de acesso para esta sala.`
            });
          },
          error: (err) => {
            this.replicatingAccess = false;
            this.poDialogService.alert({
              title: 'Erro',
              message: err?.error?.message ?? err?.message ?? 'Não foi possível copiar os registros.'
            });
          }
        });
      }
    });
  }

  loadAccessLogs(room: any, reset: boolean = false) {
    this.isHideLoadingAccessLogs = false;

    // Se for reset, limpa os logs
    if (reset) {
      this.accessLogs = [];
      this.accessLogsAll = [];
      this.accessLogsPage = 1;
      this.accessLogsHasMore = false;
      this.accessLogsRoomId = '';
      this.accessLogsDeviceMacAddress = '';
      this.accessLogsDevice = null;
      this.accessLogDateRange = null;
      this.accessLogsSearchText = '';
    }

    // Verifica se a sala tem id
    const roomId = room?.id;
    if (!roomId) {
      this.poDialogService.alert({
        title: 'Aviso',
        message: 'Esta sala não possui um ID válido.'
      });
      this.isHideLoadingAccessLogs = true;
      return;
    }

    // Armazena o roomId para próximas requisições
    if (!this.accessLogsRoomId) {
      this.accessLogsRoomId = roomId;
    }

    // Se já temos o MAC address e não é reset, faz a requisição diretamente
    if (this.accessLogsDeviceMacAddress && !reset) {
      this.loadMoreAccessLogs();
      return;
    }

    // Verifica se a sala tem deviceId
    const deviceId = room?.deviceId || room?.device?.id;
    if (!deviceId) {
      this.poDialogService.alert({
        title: 'Aviso',
        message: 'Esta sala não possui um dispositivo associado.'
      });
      this.isHideLoadingAccessLogs = true;
      return;
    }

    // Busca o dispositivo para pegar o macAddress (só na primeira vez)
    this.salasService.getDeviceById(deviceId).subscribe({
      next: (device) => {
        const macAddress = device?.macAddress || device?.mac_address || device?.MacAddress;
        if (!macAddress) {
          this.poDialogService.alert({
            title: 'Aviso',
            message: 'O dispositivo associado não possui um endereço MAC cadastrado.'
          });
          this.isHideLoadingAccessLogs = true;
          return;
        }

        // Armazena o macAddress e o dispositivo para próximas requisições
        this.accessLogsDeviceMacAddress = macAddress;
        this.accessLogsDevice = device;

        // Busca os logs de acesso usando o roomId e deviceMacAddress com paginação
        this.loadMoreAccessLogs();
      },
      error: (err) => {
        this.isHideLoadingAccessLogs = true;
        this.poDialogService.alert({
          title: 'Erro',
          message: 'Não foi possível buscar as informações do dispositivo.'
        });
      }
    });
  }

  loadMoreAccessLogs() {
    if (!this.accessLogsDeviceMacAddress) {
      this.isHideLoadingAccessLogs = true;
      return;
    }

    this.isHideLoadingAccessLogs = false;

    // Se houver pesquisa, usa pageSize de 200, senão usa o padrão
    const currentPageSize = (this.accessLogsSearchText && this.accessLogsSearchText.trim()) ? 200 : this.accessLogsPageSize;

    console.log('Carregando página:', this.accessLogsPage, 'com', currentPageSize, 'itens');

    // Formata as datas se houver período selecionado
    let startDate: string | undefined;
    let endDate: string | undefined;

    if (this.accessLogDateRange && this.accessLogDateRange.start && this.accessLogDateRange.end) {
      startDate = this.formatDateForAPI(this.accessLogDateRange.start);
      endDate = this.formatDateForAPI(this.accessLogDateRange.end);
    }

    // Prepara o search para enviar à API
    const searchTerm = (this.accessLogsSearchText && this.accessLogsSearchText.trim()) ? this.accessLogsSearchText.trim() : undefined;

    // Busca os logs de acesso usando o roomId e deviceMacAddress com paginação
    this.salasService.getAccessLogsByRoomAndDevice(
      this.accessLogsRoomId,
      this.accessLogsDeviceMacAddress,
      this.accessLogsPage,
      currentPageSize,
      startDate,
      endDate,
      searchTerm
    ).subscribe({
      next: (response: any) => {
        console.log('Resposta da API de logs:', response);

        // Verifica se a resposta tem estrutura paginada ou é um array direto
        const logsData = response.items || response.data || (Array.isArray(response) ? response : []);

        // Determina se há mais itens
        // Se a resposta tem hasNext, usa esse valor
        // Caso contrário, verifica se retornou exatamente o pageSize (pode haver mais)
        let hasNext = false;
        if (response.hasNext !== undefined) {
          hasNext = response.hasNext;
        } else if (Array.isArray(response)) {
          // Se for array direto, verifica se tem mais itens
          hasNext = response.length === currentPageSize;
        } else if (response.items) {
          // Se tiver items, verifica se retornou o pageSize completo
          hasNext = response.items.length === currentPageSize;
        }

        console.log('Logs recebidos nesta página:', logsData.length);
        console.log('Tem mais itens?', hasNext);
        console.log('Página atual (antes do incremento):', this.accessLogsPage);
        if (logsData.length > 0) {
          console.log('Estrutura do primeiro log:', logsData[0]);
          console.log('Dispositivo armazenado:', this.accessLogsDevice);
        }

        // Mapeia os logs recebidos
        const mappedLogs = (logsData || []).map((log: any) => {
          // Tenta obter o nome do dispositivo de várias fontes
          const deviceName = log.deviceName ||
            log.device?.alias ||
            log.device?.name ||
            log.deviceAlias ||
            log.device?.Alias ||
            log.device?.Name ||
            this.accessLogsDevice?.alias ||
            this.accessLogsDevice?.name ||
            this.accessLogsDevice?.Alias ||
            this.accessLogsDevice?.Name ||
            'N/A';

          return {
            userName: log.userName || 'N/A',
            userTag: this.extractTagFromDenyReason(log.denyReason) || log.userTag || log.tag || 'N/A',
            accessDate: this.formatAccessDate(log.accessDate),
            accessType: this.formatAccessType(log.isAuthorized),
            deviceName: deviceName,
            denyReason: log.denyReason || ''
          };
        });

        // Se houver pesquisa, substitui os logs, senão adiciona
        if (searchTerm) {
          // Se for pesquisa, substitui todos os logs (reset)
          this.accessLogs = mappedLogs;
          this.accessLogsAll = mappedLogs;
        } else {
          // Se não for pesquisa, adiciona normalmente (paginação)
          const logsToAdd = mappedLogs.slice(0, currentPageSize);
          console.log('Logs que serão adicionados (limitado a', currentPageSize, '):', logsToAdd.length);
          this.accessLogsAll = [...this.accessLogsAll, ...logsToAdd];
          this.accessLogs = [...this.accessLogsAll];
        }

        // Atualiza o controle de paginação
        // Se a API retornou mais itens que o pageSize, significa que há mais dados
        // ou se o hasNext já estava definido, usa esse valor
        if (mappedLogs.length > currentPageSize) {
          this.accessLogsHasMore = true;
        } else {
          this.accessLogsHasMore = hasNext;
        }

        // Incrementa a página APENAS se houver mais itens para carregar e não for pesquisa
        if (this.accessLogsHasMore && !searchTerm) {
          this.accessLogsPage++;
        }

        console.log('Total de logs exibidos agora:', this.accessLogs.length);
        console.log('Próxima página será:', this.accessLogsPage);
        console.log('Ainda tem mais?', this.accessLogsHasMore);

        this.isHideLoadingAccessLogs = true;
      },
      error: (err) => {
        this.isHideLoadingAccessLogs = true;
        this.poDialogService.alert({
          title: 'Erro',
          message: 'Não foi possível carregar os registros de acesso.'
        });
      }
    });
  }

  private extractTagFromDenyReason(denyReason: string): string | null {
    if (!denyReason) return null;
    // Formato: [D357A795:D4:E9:F4:A4:A8:18] - Access granted - master user.
    const match = denyReason.match(/\[([A-F0-9]+):/);
    return match ? match[1] : null;
  }

  private formatAccessDate(date: string | Date): string {
    if (!date) return 'N/A';
    try {
      const d = typeof date === 'string' ? new Date(date) : date;
      return d.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    } catch {
      return String(date);
    }
  }

  onAccessLogDateRangeChange() {
    // Quando o filtro de data mudar, reseta a página e recarrega os logs
    this.accessLogs = [];
    this.accessLogsAll = [];
    this.accessLogsPage = 1;
    this.accessLogsHasMore = false;
    this.loadMoreAccessLogs();
  }

  clearAccessLogDateFilter() {
    // Limpa o filtro de data e recarrega os logs sem filtro
    this.accessLogDateRange = null;
    this.accessLogs = [];
    this.accessLogsAll = [];
    this.accessLogsPage = 1;
    this.accessLogsHasMore = false;
    this.loadMoreAccessLogs();
  }

  onAccessLogsSearchChange() {
    // Dispara a busca na API com debounce
    this.accessLogsSearchSubject.next(this.accessLogsSearchText);
  }

  onAccessLogsSearchInput(event: any) {
    this.accessLogsSearchText = event.target?.value || '';
    // Dispara a busca na API com debounce
    this.accessLogsSearchSubject.next(this.accessLogsSearchText);
  }

  onAccessLogsSearchBlur() {
    // Dispara a busca na API com debounce
    this.accessLogsSearchSubject.next(this.accessLogsSearchText);
  }

  private setupAccessLogsSearch() {
    // Cancela subscription anterior se existir
    if (this.accessLogsSearchSubscription) {
      this.accessLogsSearchSubscription.unsubscribe();
    }

    // Configura o debounce para busca na API
    this.accessLogsSearchSubscription = this.accessLogsSearchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      if (searchTerm && searchTerm.trim()) {
        this.searchAccessLogsInAPI(searchTerm.trim());
      } else {
        // Se não há busca, recarrega todos os logs
        this.accessLogs = [];
        this.accessLogsAll = [];
        this.accessLogsPage = 1;
        this.accessLogsHasMore = false;
        this.loadMoreAccessLogs();
      }
    });
  }

  private searchAccessLogsInAPI(searchTerm: string) {
    if (!this.accessLogsDeviceMacAddress || !this.accessLogsRoomId) return;

    this.isHideLoadingAccessLogs = false;
    this.accessLogs = [];
    this.accessLogsAll = [];
    this.accessLogsPage = 1;
    this.accessLogsHasMore = false;

    // Formata as datas se houver período selecionado
    let startDate: string | undefined;
    let endDate: string | undefined;

    if (this.accessLogDateRange && this.accessLogDateRange.start && this.accessLogDateRange.end) {
      startDate = this.formatDateForAPI(this.accessLogDateRange.start);
      endDate = this.formatDateForAPI(this.accessLogDateRange.end);
    }

    // Busca os logs com o termo de pesquisa
    this.salasService.getAccessLogsByRoomAndDevice(
      this.accessLogsRoomId,
      this.accessLogsDeviceMacAddress,
      1,
      200, // Usa pageSize maior para pesquisa
      startDate,
      endDate,
      searchTerm
    ).subscribe({
      next: (response: any) => {
        const logsData = response.items || response.data || (Array.isArray(response) ? response : []);

        // Mapeia os logs recebidos
        const mappedLogs = (logsData || []).map((log: any) => {
          const deviceName = log.deviceName ||
            log.device?.alias ||
            log.device?.name ||
            log.deviceAlias ||
            log.device?.Alias ||
            log.device?.Name ||
            this.accessLogsDevice?.alias ||
            this.accessLogsDevice?.name ||
            this.accessLogsDevice?.Alias ||
            this.accessLogsDevice?.Name ||
            'N/A';

          return {
            userName: log.userName || 'N/A',
            userTag: this.extractTagFromDenyReason(log.denyReason) || log.userTag || log.tag || 'N/A',
            accessDate: this.formatAccessDate(log.accessDate),
            accessType: this.formatAccessType(log.isAuthorized),
            deviceName: deviceName,
            denyReason: log.denyReason || ''
          };
        });

        this.accessLogs = mappedLogs;
        this.accessLogsAll = mappedLogs;
        this.accessLogsHasMore = response.hasNext || false;
        this.isHideLoadingAccessLogs = true;
      },
      error: () => {
        this.isHideLoadingAccessLogs = true;
      }
    });
  }

  clearAccessLogsSearch() {
    this.accessLogsSearchText = '';
    // Reseta e recarrega os logs sem search
    this.accessLogs = [];
    this.accessLogsAll = [];
    this.accessLogsPage = 1;
    this.accessLogsHasMore = false;
    this.loadMoreAccessLogs();
  }

  private formatDateForAPI(date: Date | string): string {
    if (!date) return '';
    try {
      const d = typeof date === 'string' ? new Date(date) : date;
      // Usa UTC para evitar problemas de timezone
      // Formata como YYYY-MM-DD para o endpoint
      const year = d.getUTCFullYear();
      const month = String(d.getUTCMonth() + 1).padStart(2, '0');
      const day = String(d.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch {
      return '';
    }
  }

  private formatAccessType(isAuthorized: boolean): string {
    return isAuthorized ? 'Autorizado' : 'Negado';
  }

  showAccessReason(item: any) {
    const reason = item.denyReason || 'Nenhum motivo informado.';
    this.poDialogService.alert({
      title: 'Detalhes do Acesso',
      message: reason,
      literals: { ok: 'Fechar' }
    });
  }
}
